import React from "react";
import { Flame, ArrowRight } from "lucide-react";

export default function ComboDealCard({ onClick }) {
  return (
    <section id="combo" className="border-b border-border" data-testid="combo-deal-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <button
          onClick={onClick}
          className="group w-full text-left relative poster-card p-8 lg:p-12 hover:border-gold transition-colors"
          data-testid="combo-deal-card-btn"
        >
          <div className="absolute inset-0 grunge-noise opacity-40 pointer-events-none" />
          <div className="relative grid lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-2">
              <div className="font-heading text-gold text-7xl lg:text-8xl leading-none">
                £12<span className="text-3xl align-top">.99</span>
              </div>
            </div>
            <div className="lg:col-span-7">
              <div className="font-heading text-cream uppercase tracking-tight text-4xl lg:text-6xl leading-none">
                Make it a <span className="text-gold">Combo</span>
              </div>
              <p className="text-cream/75 mt-4 text-lg max-w-xl">
                Any pasta box <span className="text-gold">+</span> any 5 wings flavour. Pick your fighters and load up.
              </p>
              <div className="mt-5 flex flex-wrap gap-2 text-xs uppercase tracking-widest font-heading text-cream/70">
                <span className="px-2 py-1 border border-border">Arrabbiata</span>
                <span className="px-2 py-1 border border-border">Gochujang</span>
                <span className="px-2 py-1 border border-border">Mascarpone</span>
                <span className="px-2 py-1 border border-border">Bolognese</span>
                <span className="px-2 py-1 border border-gold text-gold">+ 5 Wings</span>
              </div>
            </div>
            <div className="lg:col-span-3 flex lg:justify-end">
              <span className="inline-flex items-center gap-2 btn-poster">
                Build Combo <ArrowRight className="h-5 w-5" />
              </span>
            </div>
          </div>
          <div className="absolute top-3 right-3 inline-flex items-center gap-1 text-accent font-heading text-sm uppercase tracking-widest">
            <Flame className="h-4 w-4" /> Best Value
          </div>
        </button>
      </div>
    </section>
  );
}
